import { aboutPoints, contactInfo } from "@/mocks/comicGuide";

export default function About() {
  return (
    <section id="about" className="bg-background-50 py-14 md:py-20">
      <div className="mx-auto grid w-full max-w-6xl grid-cols-1 items-center gap-10 px-4 lg:grid-cols-2 md:px-6">
        <div>
          <span className="inline-flex items-center gap-2 rounded-full bg-secondary-100 px-4 py-1.5 text-sm font-medium text-secondary-900">
            <i className="ri-team-line"></i> 关于我们
          </span>
          <h2 className="mt-4 font-heading text-3xl text-foreground-950 md:text-4xl">做一份真正有用的漫画阅读指南</h2>
          <p className="mt-4 text-base leading-relaxed text-foreground-600">
            我们是一群深度漫画爱好者，长期使用各类漫画阅读软件应用，把踩过的坑、总结的技巧整理成通俗易懂的内容，让每一位喜欢看漫的朋友都能用得顺手、追得更爽。
          </p>

          <ul className="mt-6 grid grid-cols-1 gap-3 sm:grid-cols-2">
            {aboutPoints.map((p) => (
              <li key={p} className="flex items-start gap-2 text-sm text-foreground-700">
                <i className="ri-checkbox-circle-line mt-0.5 text-accent-500"></i>
                <span>{p}</span>
              </li>
            ))}
          </ul>
        </div>

        <div className="rounded-3xl bg-background-950 p-8 text-background-50">
          <h3 className="font-heading text-2xl">联系我们</h3>
          <p className="mt-3 text-sm leading-relaxed text-background-300">{contactInfo.note}</p>
          <div className="mt-6 space-y-3">
            <a
              href={`mailto:${contactInfo.email}`}
              className="flex items-center gap-3 rounded-2xl bg-background-800 px-5 py-4 text-sm transition hover:bg-background-700"
            >
              <i className="ri-mail-line text-xl text-secondary-300"></i>
              <span className="break-all">{contactInfo.email}</span>
            </a>
            <div className="flex items-center gap-3 rounded-2xl bg-background-800 px-5 py-4 text-sm text-background-300">
              <i className="ri-earth-line text-xl text-secondary-300"></i>
              <span>中文内容 · 持续更新</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}